<template>
  <div>
    <top-title :name="titleName" style="margin: 20px 20px; min-width: 980px"></top-title>

    <div class="integralEden">
      <div class="content" v-if="createStep == 1">
        <!-- 头部导航切换 -->
        <div class="navTab" v-if="allHide == true">
          <span class="tab" :class="{ active: tabActive == 1 }" @click="tabActive = 1">创建活动</span>
          <span class="tab" :class="{ active: tabActive == 2 }" @click="tabActive = 2">活动管理</span>
        </div>
        <!-- 创建活动 -->
        <ul class="activity" v-show="tabActive == 1" v-loading="showLoading">
          <li class="item" v-for="item in activityForm" :key="item.id">
            <div class="wrap">
              <img :src="item.scr" class="img" />
              <div class="info">
                <span class="tit">{{ item.title }}</span>
                <span class="desc">{{ item.desc }}</span>
                <div class="btn">
                  <button v-zoom="item.zoom" @click="createActivity(item.id)">立即创建</button>
                </div>
              </div>
            </div>
          </li>
          <!-- <li class="item">
            <div class="wrap">
              <img src="../../assets/images/integralCenter/dzp.png" class="img" />
              <div class="info">
                <span class="tit">大转盘抽奖</span>
                <span class="desc">缤纷有趣转盘抽奖，助力粉丝互动，多种奖品轮番吸引，中奖率自定义，成本自控，抽奖条件随心设置，提升客户参与度</span>
                <div class="btn">
                  <button v-zoom="{ from: '忠诚度管理-积分乐园', name: '创建活动' }" @click="createActivity(1)">立即创建</button>
                </div>
              </div>
            </div>
          </li> -->
        </ul>
        <!-- 活动管理 -->
        <activity-manage
          v-if="tabActive == 2"
          :activityList="activityList"
          @changeData="changeData"
          @changeStatus="changeStatus"
          :actManag="2"
        ></activity-manage>
      </div>

      <!-- 大转盘创建活动步骤 -->
      <create-activity-step
        v-if="createStep == 2 && createStepId == 1"
        @returnBack="returnBackChange"
        :activityData="activityData"
      ></create-activity-step>
      <!-- 下单抽奖 -->
      <create-activity-step2
        v-if="createStep == 2 && createStepId == 2"
        @returnBack="returnBackChange"
        :activityData="activityData"
      ></create-activity-step2>
    </div>
  </div>
</template>

<script>
import { prefixurl } from "@/api/paradiseAndTaskCommonController.js";
import topTitle from "../../components/top-title";
import createActivityStep from "./create_activity_step";
import createActivityStep2 from "./create_activity_step2";
import activityManage from "./activityManage";
import { getSellerInfo } from "@/api/sellerController";

export default {
  components: {
    topTitle,
    createActivityStep,
    createActivityStep2,
    activityManage,
  },
  data() {
    return {
      titleName: "互动乐园",
      actManag: true,
      // 导航选中
      tabActive: 1,
      createStep: 1,
      activityData: null,
      activityForm: [
        // {
        //   id: 1,
        //   title: '大转盘抽奖',
        //   scr: require("../../assets/images/integralCenter/dzp.png"),
        //   desc: '缤纷有趣转盘抽奖，助力粉丝互动，多种奖品轮番吸引，中奖率自定义，成本自控，抽奖条件随心设置，提升客户参与度',
        //   zoom: { from: '忠诚度管理-积分乐园', name: '创建活动' },
        // },
        // {
        //   id: 2,
        //   title: '下单抽奖',
        //   scr: require("../../assets/images/integralCenter/dzp.png"),
        //   desc: '通过下单抽奖权益，商家可对会员进行下单奖励，根据奖项的不同可以设置不同的中奖概率，有效提高用户的参与积极性从而提升会员转化。',
        //   zoom: { from: '互动乐园-下单抽奖', name: '创建活动' }
        // }
      ],
      // 活动列表
      activityList: [
        {
          name: "日历签到20200526 21:43:59",
          type: "日历签到",
          startTime: "2020-04-19 22：59：17",
          endTime: "2020-04-26 23：59：59",
          lastChangeTime: "2020-05-27 16:30:49",
          createShop: "小云旗舰店",
          status: 1,
        },
        {
          name: "浏览商品有礼20200526 21:43:59",
          type: "浏览商品有礼",
          startTime: "2020-04-19 22：59：17",
          endTime: "2020-04-26 23：59：59",
          lastChangeTime: "2020-05-27 16:30:49",
          createShop: "小云旗舰店",
          status: 2,
        },
        {
          name: "日历签到20200526 21:43:59",
          type: "日历签到",
          startTime: "2020-04-19 22：59：17",
          endTime: "2020-04-26 23：59：59",
          lastChangeTime: "2020-05-27 16:30:49",
          createShop: "小云旗舰店",
          status: 3,
        },
        {
          name: "浏览商品有礼20200526 21:43:59",
          type: "浏览商品有礼",
          startTime: "2020-04-19 22：59：17",
          endTime: "2020-04-26 23：59：59",
          lastChangeTime: "2020-05-27 16:30:49",
          createShop: "小云旗舰店",
          status: 1,
        },
        {
          name: "日历签到20200526 21:43:59",
          type: "日历签到",
          startTime: "2020-04-19 22：59：17",
          endTime: "2020-04-26 23：59：59",
          lastChangeTime: "2020-05-27 16:30:49",
          createShop: "小云旗舰店",
          status: 1,
        },
      ],
      allHide: true,
      activityUrl: "",
      venderId: "",
      idUrl1: "",
      idUrl2: "",
      showLoading: true,
      createStepId: "",
    };
  },
  created() {
    this.prefixQue();
    this.getSellerInfo();
  },
  mounted() {
    if (this.$route.query.tabAct == 3) {
      this.tabActive = 2;
    }
  },
  methods: {
    //获取活动地址
    prefixQue() {
      prefixurl()
        .then((res) => {
          this.activityUrl = res.data.activityUrl;
          this.venderId = res.data.venderId;
          this.idUrl1 = this.activityUrl + "/" + "lottery_turntable" + "?venderId=" + this.venderId;
          this.idUrl2 = this.activityUrl + "/" + "clientPreview" + "?venderId=" + this.venderId + "&activityType=19";
        })
        .catch((res) => {});
    },
    createActivity(type) {
      this.createStep = 2;
      this.createStepId = type;
      switch (type) {
        case 1:
          this.titleName = "大转盘抽奖";
          this.activityData = {
            id: 1,
            telImg: require("../../assets/images/integralCenter/night_m.png"),
            telCode: this.idUrl1,
            name: "大转盘抽奖",
          };
          break;
        case 2:
          this.titleName = "下单抽奖";
          this.activityData = {
            id: 2,
            telImg: require("../../assets/images/integralCenter/night_m.png"),
            telCode: this.idUrl2,
            name: "下单抽奖",
          };
          break;
      }
    },
    returnBackChange() {
      this.createStep = 1;
      this.titleName = "互动乐园";
    },
    changeData() {
      this.allHide = false;
    },
    changeStatus() {
      this.allHide = true;
    },
    // 玩法权限
    getSellerInfo() {
      getSellerInfo().then((res) => {
        this.showLoading = false;
        res.data.permissions.forEach((item) => {
          if (item === "order:lottery") {
            this.activityForm.push({
              id: 2,
              title: "下单抽奖",
              scr: require("../../assets/images/integralCenter/xdcj.png"),
              desc: "通过下单抽奖权益，商家可对会员进行下单奖励，根据奖项的不同可以设置不同的中奖概率，有效提高用户的参与积极性从而提升会员转化。",
              zoom: { from: "互动乐园-下单抽奖", name: "创建活动" },
            });
          } else if (item === "turntable:lottery") {
            this.activityForm.push({
              id: 1,
              title: "大转盘抽奖",
              scr: require("../../assets/images/integralCenter/dzp.png"),
              desc: "缤纷有趣转盘抽奖，助力粉丝互动，多种奖品轮番吸引，中奖率自定义，成本自控，抽奖条件随心设置，提升客户参与度",
              zoom: { from: "忠诚度管理-积分乐园", name: "创建活动" },
            });
          }
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.integralEden {
  box-sizing: border-box;
  padding: 0 20px;
  min-width: 1080px;
  .content {
    min-height: 880px;
    margin: 20px 0 30px 0;
    background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .navTab {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 0 20px;
      position: relative;
      height: 50px;
      font-size: 14px;
      color: #666;
      border-bottom: 1px solid #f6f6f6;
      span {
        height: 50px;
        line-height: 50px;
        position: relative;
        padding: 0 11px;
        cursor: pointer;
        transition: all 0.2s;
      }
      .active {
        color: #2670fb;
        &::before {
          content: "";
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
          width: 80%;
          height: 2px;
          background-color: #2670fb;
          transition: all 0.2s;
          animation: opation 0.2s;
        }
        @keyframes opation {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 100%;
          }
        }
      }
    }
    .activity {
      display: flex;
      flex-wrap: wrap;
      align-content: baseline;
      box-sizing: border-box;
      padding: 30px 14px;
      list-style: none;
      height: 500px;
      min-width: 1366px;
      .item {
        flex: 1;
        max-width: 33.33%;
        min-width: 480px;
        box-sizing: border-box;
        padding: 0 14px;
        margin-bottom: 20px;
        .wrap {
          display: flex;
          box-sizing: border-box;
          padding: 0 15px;
          height: 220px;
          box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
          border-radius: 6px;
          background-color: #fff;
          transition: all 0.2s;
          &:hover {
            box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.2);
          }
          .img {
            flex-shrink: 0;
            height: 200px;
            margin-top: 14px;
          }
          .info {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 30px 0 16px 0;
            .tit {
              font-size: 16px;
              color: #333;
            }
            .desc {
              margin: 15px 0;
              font-size: 14px;
              line-height: 24px;
              color: #333;
            }
            .btn {
              text-align: right;
              button {
                width: 94px;
                height: 32px;
                line-height: 28px;
                text-align: center;
                border-radius: 2px;
                border: 1px solid #2670fb;
                color: #2670fb;
                background-color: #fff;
                cursor: pointer;
                outline: none;
                transition: all 0.2s;
                &:hover {
                  background-color: #2670fb;
                  color: #fff;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
